/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ICashFlowBudgetClassification } from 'views/ProFormaTable/types';
import { numeralFormatter, numeralFormatterCurrency } from 'ns_libs/formatter';
import { Progress } from 'reactstrap';
import { format, parse } from 'date-fns';
import { getProjectActualsCategoryLevelTotals } from 'views/ProFormaTable/helpers';
import { useProFormaSocketContext } from 'views/ProFormaTable/components/ProForma/socketContext/ProFormaSocketProvider';
import { Periods } from 'components/ProFormaReturnsTable/constant';
import { useUsesActualsTableContext } from '../../../context/UsesTableActualsProvider';
import ProjectActualsCashFlowPeriods from '../../../ProjectActualsCashFlowPeriods/ProjectActualsCashFlowPeriods';

export interface IUsesTableBudgetLineActuals {
    budgetClassification: ICashFlowBudgetClassification;
}

const UsesTableBudgetLineActuals = ({ budgetClassification }: IUsesTableBudgetLineActuals) => {
    const { periodCadence, showCents } = useProFormaSocketContext();

    const {
        forecastMetric, isEarlyPlanningProject, selectedScenario,
    } = useUsesActualsTableContext();

    const categoryTotals = getProjectActualsCategoryLevelTotals(forecastMetric, budgetClassification, isEarlyPlanningProject, selectedScenario);

    const progressPercentage = categoryTotals.budgetTotal ? (1 - (categoryTotals.balanceRemaining / categoryTotals.budgetTotal)) : 0;
    const progressBarClassName = 'NSTable__tbody__tr__td--progress-bar NSTable__tbody__tr__td--progress-bar--green';

    const startDate = budgetClassification.startDate ? parse(budgetClassification.startDate, 'yyyy-MM-dd', new Date()) : null;
    const endDate = budgetClassification.endDate ? parse(budgetClassification.endDate, 'yyyy-MM-dd', new Date()) : null;

    let periods = budgetClassification.periodData || [];
    if (periodCadence === Periods.ANNUALLY) {
        periods = budgetClassification.yearlyPeriodData || [];
    }

    const showCentsFormat = showCents ? '$0,0.00' : '$0,0';

    return (
        <tr className="NSTable__tbody__tr NSTable__tbody__tr--level-3 text-dark">
            <td
                className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border h-100"
            >
                <div className="d-flex align-items-center h-100 ml-4">
                    {budgetClassification.description}
                </div>
            </td>
            <td className="NSTable__tbody__tr__td align-middle">
                <div className="d-flex align-items-center">
                    <div className="w-100 mr-2">
                        <Progress
                            color="primary"
                            className={progressBarClassName}
                            value={Math.round(progressPercentage * 100)}
                        />
                    </div>
                    <span>{numeralFormatter(progressPercentage, '0%')}</span>
                </div>
            </td>
            <td className="NSTable__tbody__tr__td">
                <div className="d-flex justify-content-end">{numeralFormatterCurrency(categoryTotals.budgetTotal, showCentsFormat)}</div>
            </td>
            <td className="NSTable__tbody__tr__td">
                <div className="d-flex justify-content-end">{numeralFormatterCurrency(categoryTotals.balanceRemaining, showCentsFormat)}</div>
            </td>
            <td className="NSTable__tbody__tr__td">
                <div className="d-flex justify-content-end text-nowrap">
                    {startDate ? format(startDate, 'MMM dd, yyyy') : '—'}
                </div>
            </td>
            <td className="NSTable__tbody__tr__td">
                <div className="d-flex justify-content-end text-nowrap">
                    {endDate ? format(endDate, 'MMM d, yyyy') : '—'}
                </div>
            </td>

            <ProjectActualsCashFlowPeriods
                periods={periods}
                showCentsFormat={showCentsFormat}
            />

        </tr>
    );
};

export default UsesTableBudgetLineActuals;
